import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, propTypes as reduxFormPropTypes } from 'redux-form';
import { get, isNil } from 'lodash';
import { compose } from 'recompose';
import { questionTypes } from '@nextiva/engagement-ui';

import CommentsField from 'components/CommentsField';
import isQuestionCommentsDisabled from 'utils/isQuestionCommentsDisabled';
import { debouncedReduxForm } from 'sharedParts';
import { getQuestionConfigLimits } from 'sharedParts/config/blockConfig';

import withTakerValidator from '../../hoc/withTakerValidator';
import RatingContainer from '../RatingContainer';
import propTypeBlockStyling from '../../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

import styles from './RatingForm.scss';

const { min, max } = getQuestionConfigLimits(questionTypes.questionScale).itemList;

class RatingForm extends Component {
  static propTypes = {
    block: PropTypes.shape({
      required: PropTypes.bool,
      shape: PropTypes.string.isRequired,
      color: PropTypes.string,
      personalLabelType: PropTypes.string,
    }).isRequired,
    itemListCount: PropTypes.number,
    ratingField: PropTypes.func.isRequired,
    ratingItemClassName: PropTypes.string,
    readOnly: PropTypes.bool,
    minCount: PropTypes.number,
    maxCount: PropTypes.number,
    cancelSubmit: PropTypes.func.isRequired,
    flushSubmit: PropTypes.func.isRequired,
    styling: propTypeBlockStyling,
    validator: PropTypes.arrayOf(PropTypes.func),
    ...reduxFormPropTypes,
  };

  static defaultProps = {
    readOnly: false,
    itemListCount: 0,
    maxCount: max,
    minCount: min,
  };

  componentWillUnmount() {
    this.props.cancelSubmit();
  }

  render() {
    const {
      block,
      block: { commentsEnabled, commentsLabel },
      itemListCount,
      ratingField,
      ratingItemClassName,
      ratingContainerClassName,
      initialValues: answer,
      readOnly,
      maxCount,
      minCount,
      flushSubmit,
      validator,
      styling,
    } = this.props;

    return (
      <div className={styles.container}>
        <RatingContainer className={ratingContainerClassName}>
          <Field
            name="value"
            component={ratingField}
            format={null}
            validate={validator}
            props={{
              itemListCount,
              block,
              readOnly,
              maxCount,
              minCount,
              ratingItemClassName,
              hasAnswer: !isNil(get(answer, 'value')),
              styling,
            }}
          />
        </RatingContainer>
        <Field
          name="comments"
          component={CommentsField}
          onBlur={flushSubmit}
          props={{
            readOnly,
            className: styles.comments,
            disabled: isQuestionCommentsDisabled(this.props),
            commentsEnabled,
            commentsLabel,
            styling,
          }}
        />
      </div>
    );
  }
}

export default compose(
  debouncedReduxForm({
    form: 'RatingForm',
    enableReinitialize: true,
    isAutoSubmit: true,
  }),
  withTakerValidator,
)(RatingForm);
